import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "./AdminAuthContext";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import AdminDashboard from "./AdminDashboard";
import AdminUsers from "./AdminUsers";
import AdminReferrals from "./AdminReferrals";
import AdminArchetypes from "./AdminArchetypes";
import AdminPricing from "./AdminPricing";
import AdminAccessCodes from "./AdminAccessCodes";
import AdminFeedback from "./AdminFeedback";
import AdminCosts from "./AdminCosts";
import AdminMarkets from "./AdminMarkets";
import AdminFunnel from "./AdminFunnel";

function RequireAdmin({ children }) {
    const { admin, loading } = useAdminAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream text-ink-muted text-sm">
                Loading…
            </div>
        );
    }
    if (!admin) {
        return <Navigate to="/admin" state={{ from: location }} replace />;
    }
    return children;
}

function AdminEntry() {
    const { admin, loading } = useAdminAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream text-ink-muted text-sm">
                Loading…
            </div>
        );
    }
    if (!admin) return <AdminLogin />;
    return <Navigate to="/admin/overview" replace />;
}

export default function AdminApp() {
    return (
        <AdminAuthProvider>
            <Routes>
                <Route path="/" element={<AdminEntry />} />
                <Route
                    element={
                        <RequireAdmin>
                            <AdminLayout />
                        </RequireAdmin>
                    }
                >
                    <Route path="overview" element={<AdminDashboard />} />
                    <Route path="costs" element={<AdminCosts />} />
                    <Route path="users" element={<AdminUsers />} />
                    <Route path="markets" element={<AdminMarkets />} />
                    <Route path="funnel" element={<AdminFunnel />} />
                    <Route path="referrals" element={<AdminReferrals />} />
                    <Route path="archetypes" element={<AdminArchetypes />} />
                    <Route path="pricing" element={<AdminPricing />} />
                    <Route path="access-codes" element={<AdminAccessCodes />} />
                    <Route path="feedback" element={<AdminFeedback />} />
                </Route>
                <Route path="*" element={<Navigate to="/admin" replace />} />
            </Routes>
        </AdminAuthProvider>
    );
}
